<template>
  <div id='app'>
    <router-view/>
  </div>
</template>

<script>
export default {
  created() {
    this.initToken()
  },
  methods: {
    initToken() {
      let token = localStorage.getItem('WAITU_TOKEN')
      let libraryToken = localStorage.getItem('WAITU_LIBRARY_TOKEN')
      if (token) {
        let payload = {
          key: 'token',
          val: token
        }
        this.$store.commit('updateStrData',payload)
      }
      if (libraryToken) {
        let payload = {
          key: 'libraryToken',
          val: libraryToken
        }
        this.$store.commit('updateStrData',payload)
      }
    }
  },
}
</script>

<style>
#app {
  font-family: "microsoftYaHei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue